import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, anchors: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App bg-[#03070A] text-[#F4F4F0] min-h-screen">
            <div className="grain-overlay" />
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Services />
                <Gallery />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
